export default {
	onAiTopNavClicked: 'onAiTopNavClicked',
	onAiInputBoxClick: 'onAiInputBoxClick',
	onAiPromptClick: 'onAiPromptClick',
	onAiPromptBackClick: 'onAiPromptBackClick',
	onAiPromptInterestShown: 'onAiPromptInterestShown',
	onAiInChatPromptClick: 'onAiInChatPromptClick',
	onCommunityAIPromptClick: 'onCommunityAIPromptClick',
	onCommunityAISummaryClick: 'onCommunityAISummaryClick',
	onAiBackgroundMicClick: 'onAiBackgroundMicClick',
};
